import { validator_messages } from './constants';

export const strongPasswordValidator = (rule, value) => {
  let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{7,15}$/;
  if (value !== undefined && !value.match(passwordRegex)) {
    return Promise.reject(
      validator_messages.STRONG_PASSWORD_HINT
    );
  }
  return Promise.resolve();
};


export const usernameValidator = async (rule, value) => {
  const re = /^[a-zA-Z0-9_]{7,15}$/;

  if(value !== undefined && value !=="" && value !== null)
  {
    if (re.test(value)) {
        return value;
    } else {
        throw new Error(validator_messages.STRONG_USERNAME);
    }  
  }
}